import { useAtom } from "jotai";
import { editOrderAtom } from "../atoms";
import { objectIsEmpty } from "../utils/helpers";

const useIsOrderEditingHook = () => {
  const [editOrder, setEditOrder] = useAtom(editOrderAtom);
  return {
    isOrderEditing: objectIsEmpty(editOrder) === false,
    editOrder,
    setEditOrder,
  };
};

export default useIsOrderEditingHook;
